import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { Breadcrumb as SEOBreadcrumb } from "@seo/breadcrumb";
import { HouseIcon } from "@gemini/icons";
import { useClassified } from "@/contexts/classified";
export const Breadcrumb = () => {
    var _a, _b, _c, _d;
    const links = (_d = (_c = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.seo) === null || _b === void 0 ? void 0 : _b.breadcrumb) === null || _c === void 0 ? void 0 : _c.links) !== null && _d !== void 0 ? _d : [];
    const breadcrumbIcon = () => _jsx(HouseIcon, { marginHorizontal: "spacing.12" });
    const addBreadcrumbIcon = (links) => {
        return links.map((link) => link.order === 1
            ? Object.assign(Object.assign({}, link), { icon: breadcrumbIcon }) : link);
    };
    const breadcrumbLinks = links && (links === null || links === void 0 ? void 0 : links.length) > 0 ? addBreadcrumbIcon(links) : [];
    return (_jsx(Box, { gridColumn: {
            "breakpoint.base": "col-start / span 4",
            "breakpoint.sm": "col-start / span 8",
            "breakpoint.xl": "col-start 1 / span 12",
            "breakpoint.xxl": "col-start 2 / span 10",
        }, unsafe_className: "HideOnPrint", children: _jsx(Box, { marginLeft: {
                "breakpoint.base": "spacing.16",
                "breakpoint.md": "spacing.32",
                "breakpoint.lg": "spacing.none",
                "breakpoint.xl": "spacing.none",
            }, marginRight: "spacing.16", children: _jsx(SEOBreadcrumb, { links: breadcrumbLinks, hideItems: false, lastItemEllipsis: false, paddingLeft: "0", marginHorizontal: "0" }) }) }));
};
